import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import { elementsActions, alertActions } from '../../redux/actions';

import { FileUploaderDropContainer } from '@carbon/react';
import { openElementUploadForm } from '@/redux/new_services/forms';

const allowedResolutions = [
  { width: 1920, height: 1920, orientation: 2 },
  { width: 1920, height: 1080, orientation: 0 },
  { width: 1080, height: 1920, orientation: 1 },
  { width: 1366, height: 1366, orientation: 2 },
  { width: 1366, height: 768, orientation: 0 },
  { width: 1280, height: 720, orientation: 0 },
  { width: 720, height: 1280, orientation: 1 },
  { width: 768, height: 1366, orientation: 1 },
];

const getVideoDimensions = (url) => {
  return new Promise((resolve) => {
    const video = document.createElement('video');

    video.addEventListener(
      'loadedmetadata',
      () => {
        const height = video.videoHeight;
        const width = video.videoWidth;
        const duration = Math.floor(video.duration);
        resolve({
          width,
          height,
          duration,
          type: 1,
        });
      },
      false
    );


    video.src = url;
  });
};

const getImageDimensions = (url) => {
  return new Promise((resolve) => {
    var image = new Image();

    image.onload = () => {
      const width = image.width;
      const height = image.height;

      resolve({
        width,
        height,
        duration: 10,
        type: 0,
      });
    };

    image.src = url;
  });
};

const extractInformations = (filename) => {
  let filename_without_extension = filename.replace(/\.[^/.]+$/, '');

  let name = filename_without_extension;
  let tags = [];
  let orientation = -1;

  const parts = filename_without_extension.split('_');
  if (parts[0].match(/ger.*t/i) || parts[0].match(/tr5/i)) {
    // put in category Gerät
    console.info('es ist ein Gerät...');
    const hersteller = parts[1];

    tags = ['Geldspielgeräte', hersteller, parts[0].match(/tr5/i) && 'TR5'];

    const geraete_name = parts[2].replace('-', ' ');

    const rotation = parts[parts.length - 1];

    if (rotation === 'H' || rotation === 'h') {
      orientation = 1;
    }
    if (rotation === 'Q' || rotation === 'q') {
      orientation = 0;
    }
    if (rotation === 'M' || rotation === 'm') {
      orientation = 2;
    }

    name = geraete_name;
  } else {
    orientation = -1;
    // check for templates
    if (name.includes('Micast_Screenvorlage_1920x1920px_')) {
      let p = name.replace('Micast_Screenvorlage_1920x1920px_', '');
      name = p.replace('_', ' ');
    }
    if (name.includes('Micast_Screen_1920x1080px_Q_')) {
      let p = name.replace('Micast_Screen_1920x1080px_Q_', '');
      name = p.replace('_', ' ');
    }
    if (name.includes('Micast_Screen_1920x1080px_H_')) {
      let p = name.replace('Micast_Screen_1920x1080px_H_', '');
      name = p.replace('_', ' ');
    }
    if (name.includes('Micast_Screen_1080x1920px_H_')) {
      let p = name.replace('Micast_Screen_1080x1920px_H_', '');
      name = p.replace('_', ' ');
    }
    if (name.includes('Screen_Micast_1920x1920px_')) {
      let p = name.replace('Screen_Micast_1920x1920px_', '');
      name = p.replace('_', ' ');
    }
  }

  return { name, tags, orientation };
};

const DropField = memo(
  ({
    allowedFiles = ['video/mp4', 'image/png', 'image/jpeg'],
    labelText = 'Hier neue Elemente hinzufügen',
    handleUpload = () => {},
    multiple = true,
  }) => {
    return (
      <FileUploaderDropContainer
        labelText={labelText}
        multiple={multiple}
        accept={allowedFiles}
        onAddFiles={handleUpload}
      />
    );
  }
);

const Upload = memo(
  ({
    singleUpload = false,
    allowedFiles = ['video/mp4', 'image/png', 'image/jpeg'],
    dispatchActions = true,
    labelText = 'Hier neue Elemente hinzufügen',
    handleAction = () => {},
  }) => {
    const dispatch = useDispatch();

    const handleUpload = (e, { addedFiles }) => {
      let promises = [];

      addedFiles.forEach((file) => {
        promises.push(
          new Promise((resolve, reject) => {
            if (file.size > 209715200) {
              dispatch(
                alertActions.error(
                  `Das Element '${file.name}' ist zu Groß und kann nicht verabreitet werden`,
                  'Vorbereitung'
                )
              );
              reject();
            } else {
              /*dispatch(
                alertActions.success(
                  `Verarbeite Element '${file.name}'`,
                  'Vorbereitung'
                )
              );*/

              let blob = file;
              let blob_type = blob.type;
              let uri = URL.createObjectURL(blob);

              /*const reader = new FileReader();

              reader.onabort = () => reject();
              reader.onerror = () => reject();
              reader.onload = () => {
                // Do whatever you want with the file contents
                const binaryStr = reader.result;*/


              let dimensionsMethod;
              if (blob_type.includes('video')) {
                // oh, es ist ein video!
                dimensionsMethod = getVideoDimensions;
              } else {
                dimensionsMethod = getImageDimensions;
              }

              console.info("make the dimensions check...");
              dimensionsMethod(uri).then(
                ({ width, height, duration, type }) => {
                  let resolution = allowedResolutions.find(
                    (r) => r.width === width && r.height === height
                  );
                  if (resolution) {
                    console.info('file:', file);
                    const pre_settings = extractInformations(file.name);
                    console.info('pre_settings', pre_settings);

                    let custom_resolution = { ...resolution };

                    resolve({
                      filename: '',
                      name: pre_settings.name,
                      tags: pre_settings.tags,
                      blob: uri,
                      file: file,
                      /*file: {
                        name: file.name,
                        type: file.type,
                        size: file.size,
                      },*/
                      resolution: custom_resolution,
                      duration,
                      type,
                    });
                  } else {
                    dispatch(
                      elementsActions.showResolutionWarning(
                        'Das Bild hat eine ungültige Auflösung!',
                        <div><p><b>Gültige Auflösungen sind:</b></p> <br/><p>1920x1080, 1080x1920, 1920x1920, 1280x720 und 720</p><br/><b>Hier wird in kürze ein Editor eingebaut.</b></div>
                      )
                    );
                    reject();
                  }
                }
              );
              //};
              //reader.readAsDataURL(file);
            }
          })
        );
      });

      Promise.all(promises).then((forms) => {
        console.info("finished loading url");
        if (dispatchActions === false) {
          handleAction(forms);
        } else {
          console.info("DISPATCH ACTIONS...");
          dispatch(openElementUploadForm(forms));
        }
      });
    };

    return (
      <DropField
        handleUpload={handleUpload}
        multiple={!singleUpload}
        labelText={labelText}
        allowedFiles={allowedFiles}
      />
    );
  }
);

export default Upload;
